import commonEnHK from './common_en-HK'

const rtEnHK = {
  rt: {
    ...commonEnHK,
  }
}

export default rtEnHK